import { AuthenticatedDataRequest } from '@eggplant/data-request'
import {
  Combobox,
  DropdownButton,
  Icons,
  NoOptionsPlaceholder
} from '@eggplant/pattern-library'
import { FiTag } from 'react-icons/fi'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  ButtonShape,
  DropdownPlacement,
  Options,
  Tag
} from '@eggplant/types'

interface Props {
  onChange: (value: string) => void
  placeholder?: string
  value?: string
  dropdownPlacement?: DropdownPlacement
  isFilterFixedMinMaxWidth?: boolean
}

const url = MODELER_SERVICE + '/tags'

const getOptions = (items: Tag[] | undefined) => {
  if (!Array.isArray(items)) return []

  return items.map(item => ({
    label: item.name,
    value: item.id
  }))
}

const dropDownIcon = () => <Icons.TestCaseTag size='20' />

const SelectTestCaseTag = ({
  onChange,
  placeholder = 'Test case tag',
  value,
  dropdownPlacement = 'bottom',
  isFilterFixedMinMaxWidth = true
}: Props) => {
  const renderButton = (options: Options) => {
    const currentOption = options.find(item => item.value === value)

    const label = currentOption?.value
      ? currentOption.label
      : placeholder

    const tooltip = currentOption?.value
      ? `Test case tag: ${currentOption.label}`
      : label

    const buttonText = currentOption?.value
      ? currentOption.label
      : placeholder

    return (buttonProps: ButtonShape) =>
      <DropdownButton
        {...buttonProps}
        Icon={dropDownIcon}
        dropdownPlacement={dropdownPlacement}
        isFilter
        isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
        isHighlighted={!!value}
        label={label}
        title={tooltip}
      >
        {buttonText}
      </DropdownButton>
  }

  const noDataPlaceholder =
    <NoOptionsPlaceholder
      icon={
        <Icons.TestCaseTag
          aria-hidden
          size='24px'
        />
      }
      title='No test case tag found'
    />

  return (
    <AuthenticatedDataRequest
      method='get'
      shortErrorMessage='Failed to load Test case tag'
      url={url}
    >
      {
        ({ items }) =>
          <Combobox
            dropdownPlacement={dropdownPlacement}
            isFilter
            isFilterFixedMinMaxWidth={isFilterFixedMinMaxWidth}
            noOptionsPlaceholder={noDataPlaceholder}
            onChange={onChange}
            options={getOptions(items)}
            renderButton={renderButton(getOptions(items))}
            value={value}
          />
      }
    </AuthenticatedDataRequest>
  )
}

export default SelectTestCaseTag
